// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'video-off';

export const Component = () => (
  <>
    <path d='M14.333 6H2.485c-.431 0-.766.144-1.054.431S1 7.054 1 7.485v9.818c0 .431.144.766.431 1.054s.623.431 1.054.431h3.323l.67-1.005H2.486c-.335 0-.527-.144-.527-.48V7.487c0-.335.192-.479.527-.479h11.176z' />
    <path
      fillRule='evenodd'
      d='m9.908 18.788.694-1.005h6.587c.335 0 .479-.144.479-.48V7.55l.687-.995c.212.26.318.56.318.93v1.82l4.31-3.114A.919.919 0 0 1 23.56 6c.239 0 .478.096.718.287a.977.977 0 0 1 .288.72v10.776a.943.943 0 0 1-.288.67c-.239.24-.479.335-.718.335a.922.922 0 0 1-.575-.191l-4.31-3.113v1.82c0 .43-.144.765-.432 1.053s-.623.431-1.054.431zM23.56 7.007v10.776l-4.885-3.496v-3.784zM19.481 2.1c.144.145.192.24.192.384s-.048.24-.096.287L5.784 22.407a.435.435 0 0 1-.383.191c-.335 0-.48-.143-.48-.478 0-.144.049-.24.097-.288L18.763 2.196a.435.435 0 0 1 .383-.191c.048 0 .144.047.335.096z'
    />
  </>
);

export const viewBox = '0 0 25 25';
